// src/components/Admin/AdminApp.jsx
// Módulo /admin autocontenido: login propio de empleados + panel.
// No usa el AuthContext del usuario; su token vive en sessionStorage.
import { useState } from 'react';
import { FiLock, FiShield, FiAlertTriangle } from 'react-icons/fi';
import { API_URL } from '../../services/apiClient';
import { getAdminToken, setAdminToken, clearAdminToken } from '../../services/adminClient';
import AdminPanel from './AdminPanel';
import './Admin.css';

export default function AdminApp() {
  const [token, setToken] = useState(getAdminToken());

  if (!token) {
    return <AdminLogin onLogin={(t) => { setAdminToken(t); setToken(t); }} />;
  }
  return <AdminPanel onLogout={() => { clearAdminToken(); setToken(null); }} />;
}

function AdminLogin({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) { setError(data.message || 'No se pudo entrar'); return; }
      onLogin(data.token);
    } catch {
      setError('No se pudo conectar al servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adm-login-screen">
      <div className="adm-login-fx" aria-hidden="true" />
      <form className="adm-login-card" onSubmit={submit}>
        <div className="adm-login-shield"><FiShield /></div>
        <img className="adm-login-logo" src="/assets/Logo-White.png" alt="Bitplify" />
        <div className="adm-login-tagrow"><FiLock /> Panel interno · acceso restringido</div>
        <p className="adm-login-sub">Solo personal autorizado de Bitplify. Los accesos quedan registrados.</p>

        <label className="adm-field">
          <span>Email corporativo</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            autoComplete="username" required autoFocus />
        </label>
        <label className="adm-field">
          <span>Contraseña</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password" required />
        </label>

        {error && <div className="adm-login-error"><FiAlertTriangle /> {error}</div>}

        <button className="adm-btn adm-btn-primary adm-login-btn" type="submit" disabled={loading}>
          <FiLock /> {loading ? 'Verificando…' : 'Entrar seguro'}
        </button>

        <div className="adm-login-secbadges">
          <span><FiLock /> Cifrado SSL / TLS</span>
          <span><FiShield /> Accesos monitoreados</span>
        </div>
      </form>
    </div>
  );
}
